import MainCard from "src/components/material/Cards/MainCard";
import React, { useContext, useEffect } from 'react'
import { Stack } from '@mui/material'
import Grid from "@mui/material/Unstable_Grid2";
import CycleSummaryContainer from './CycleSummary/CycleSummaryContainer'
import CyclesByOperatorContainer from './CyclesByOperator/CyclesByOperatorContainer'
import WasteProcessedContainer from './WasteProcessed/WasteProcessedContainer'
import CycleReportContainer from './CycleReport/CycleReportContainer'
import SterilizationInfoContainer from './SterilizationInfo/SterilizationInfoContainer'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCustomerInfo, fetchCustomerCycles, fetchCustomers, fetchCustomerDevices } from "./summaryDashboardSlice";
import Toolbar from "./Toolbar/Toolbar";
import { setSelectedCustomer, setSelectedFacilities } from "./summaryDashboardSlice";
import BioChallengeTable from "./BioChallenge/BioChallengeTable";
import { UserContext } from "src/components/library/UserContext";
import withAuth from "src/components/withAuth";

const SummaryDashboard = (props) => {
    const dispatch = useDispatch();
    const userContext = useContext(UserContext);
    const { user, group } = userContext;
    const [useCustomerDropdown, setUseCustomerDropdown] = React.useState(["SterilisWasteTypeAdmin", "SterilisSuperUsers"].includes(group));
    const {
        deviceConfigIds,
        customer,
        // @ts-ignore
    } = useSelector((store) => store.summarydashboard);

    const { customerDropdown, selectedCustomer } = useSelector((store) => store.summarydashboard);

    const customerId = props.match.params["customer_id"] ? Number(props.match.params["customer_id"]) : null;

    useEffect(() => {
        const isCustomerAdmin = ["SiteAdmin", "FacilityAdmin"].includes(group)
        if (group && isCustomerAdmin) {
            setUseCustomerDropdown(false);
            // @ts-ignore
            dispatch(setSelectedCustomer(customerDropdown.find((c) => c.id === user.customer_id)));
        }

        if (customerId) {
            // @ts-ignore
            dispatch(fetchCustomerDevices(customerId));
        }

        return () => {
            dispatch(setSelectedCustomer(null));
            dispatch(setSelectedFacilities([]));
        }
    }, []);

    useEffect(() => {
        if (useCustomerDropdown && customerDropdown.length === 0) {
            // @ts-ignore
            dispatch(fetchCustomers());
            //dispatch(fetchCustomerDevices(selectedCustomer?.id));
        }
    }, []);

    useEffect(() => {
        if (selectedCustomer) {
            dispatch(setSelectedFacilities([]));
            //dispatch(fetchCustomerInfo(selectedCustomer.id));
            dispatch(fetchCustomerDevices(selectedCustomer.id));
        }
    }, [selectedCustomer]);

    useEffect(() => {
        if (customerId && customerDropdown.length > 0) {
            // @ts-ignore
            dispatch(setSelectedCustomer(customerDropdown.find((c) => c.id === Number(customerId))));
        }
    }, [customerDropdown]);

    useEffect(() => {
        if (deviceConfigIds && deviceConfigIds.length > 0) {
            // @ts-ignore
            dispatch(fetchCustomerCycles());
        }
    }, [deviceConfigIds]);


    return (
        <MainCard>
            <Toolbar useCustomerDropdown={useCustomerDropdown} />
            <Grid container spacing={2}>
                <Grid xs={12} lg={5} sx={{ display: "flex" }}>
                    <CycleSummaryContainer />
                </Grid>
                <Grid xs={12} md={6} lg={3} sx={{ display: "flex" }}>
                    <CyclesByOperatorContainer />
                </Grid>
                <Grid xs={12} md={6} lg={4} sx={{ display: "flex" }}>
                    <WasteProcessedContainer />
                </Grid>
                <Grid xs={12} lg={8} sx={{ display: "flex" }}>
                    <CycleReportContainer />
                </Grid>
                <Grid xs={12} lg={4} sx={{ display: "flex" }}>
                    <Stack direction={"column"} spacing={2} width={"100%"}>
                        <SterilizationInfoContainer />
                    </Stack>
                </Grid>
                <Grid xs={12} lg={12} sx={{ display: "flex" }}>
                    <BioChallengeTable customerIdParam={customerId} />
                </Grid>
            </Grid>

        </MainCard>
    )
}

export default withAuth([
    "SterilisSuperUsers",
    "CustomerPortalUsers",
    "SterilisPortalUsers",
    "FSEs",
    "ExternalFSEs",
    "FactoryWorkers",
    "DistributorAdmins",
    "DistributorReadOnly",
    "DistributorFSEs",
    "SterilisWasteTypeAdmin",
    "FacilityAdmin"
])(SummaryDashboard);
